import React from 'react';
import { Card as MuiCard } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Primitive Card component
 * Styled version of MUI Card that respects the theme
 */
const Card = ({ children, elevation = 1, ...props }) => {
  const theme = useTheme();

  return (
    <MuiCard
      elevation={elevation}
      {...props}
      sx={{
        ...props.sx,
      }}
    >
      {children}
    </MuiCard>
  );
};

export default Card;

